// extracted by mini-css-extract-plugin
export default {"button":"DownloadChartButton_button__TpDRO"};